import { type AuthorizedPois, type PaymentProfile } from 'dashboard-experience/shared/services'

export type AuthorizedPoi = keyof AuthorizedPois

export function hasAuthorizedPoisAcrossProfiles(
  paymentProfiles: PaymentProfile[] | undefined,
  pois: AuthorizedPoi[]
): boolean {
  if (!paymentProfiles?.length || !pois.length) return false

  const enabledPois = paymentProfiles.flatMap(({ authorizedPois }) =>
    authorizedPois ? (Object.keys(authorizedPois) as AuthorizedPoi[]).filter(poi => authorizedPois[poi]) : []
  )

  return pois.every(poi => enabledPois.includes(poi))
}
